module.exports = __webpack_public_path__ + "static/media/aboutUpdate.d00b8582.jpg";